module.exports = __webpack_public_path__ + "static/media/cancel-transfer.svg.2a08b42d.png";